import { useUserSettings } from '../../../utils/use-user-settings';
import { isFeatureEnabled } from '../../../utils/feature-flags';
import ReportDrawerDetailsOld from './report-drawer-details-old';
import ReportDrawerDetails from './report-drawer-details';

export default function ReportDrawerDetailsPage() {
  const { features } = useUserSettings();
  const isReportUiUpdateEnabled = isFeatureEnabled(
    'uiEnhancementPhase2',
    features
  );
  return isReportUiUpdateEnabled ? (
    <ReportDrawerDetails />
  ) : (
    <ReportDrawerDetailsOld />
  );
}
